import { apiSlice } from "@app/api/apiSlice";
import { useSubmit } from "react-router-dom";

export const consumerPurchaseManageApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadSliderSection: builder.query({
      query: (key) => `slider/key/${key || 'samsung-carousel'}`,
    }),
    loadProductsAvailableSchemePublic: builder.query({
      query: (query) => `scheme/offer?${query}`,
      // query: (query) => `/api/scheme/offer?campaign=handriser-s26&retailer=CTLD00032`,
      // response is in format {"data":[],"success":true,"msg":{"_id":"669107086c9dfbc967a32a98","payment_qr":{"_id":"68886ac3df3c411457d3748a","folder_id":"68886ab6df3c411457d37461","originalname":"qr_him.jpg","renamed_name":"qr_him.jpg","encoding":"7bit","mimetype":"image/jpeg","destination":"public/files/","filename":"B2941BA05B00355-qr_him.jpg","path":"public/files/B2941BA05B00355-qr_him.jpg","size":158460,"is_deleted":false,"added_by":"5e452f6a754d7382f49d2013","added_at":"2025-07-29T06:31:31.404Z","__v":0},"campaign":{"_id":"6992ac99723488c93f808d46","name":"Handraiser Offer","start_date":"2026-02-19T18:15:00.000Z","end_date":"2026-02-26T18:15:00.000Z","description":"<p>Galexy S26 Family</p>\n","code":"handriser-s26","is_handraiser":true,"handraiser_details":{"start_date":"2026-02-17T18:15:00.000Z","end_date":"2026-02-18T18:15:00.000Z","allowed_devices":[{"device":"S25 Ultra","model":["12+256GB","12+512GB","12+1TB"],"_id":"6992ac99723488c93f808d47"},{"device":"S24","model":["12+256GB","12+512GB"],"_id":"6992ac99723488c93f808d48"}],"pre_order_opening_date":"2026-02-18T18:15:00.000Z","new_device_options":[{"device":"Ultra","model":[{"name":"16+1TB","stock":10,"_id":"6996f1e1098c4abcd3936582"},{"name":"12+512GB","stock":10,"_id":"6996f1e1098c4abcd3936583"},{"name":"12+256GB","stock":10,"_id":"6996f1e1098c4abcd3936584"}],"_id":"69954a7572483003bc91cedd"},{"device":"Plus","model":[{"name":"12+256GB","stock":10,"_id":"6996f1e1098c4abcd3936586"}],"_id":"6996a0ad54c857198f33da48"},{"device":"Base","model":[{"name":"12+256GB","stock":10,"_id":"6996f1e1098c4abcd3936588"}],"_id":"6996a0ad54c857198f33da49"}],"pre_order_closing_date":"2026-02-20T18:15:00.000Z"}},"stage":"HANDRAISER_PRE_ORDER"},"page":1,"size":1000,"sort":{"_id":-1},"totalData":0}
      //
    }),
    loadAllOfficeByType: builder.query({
      query: () => `office/public?find_type=RETAILER`,
    }),

    loadStateLocation: builder.query({
      query: (query) => `static/public/nepal/state`,
    }),
    loadDistrictLocation: builder.mutation({
      query: (id) => `static/public/nepal/state/${id}`,
    }),
    loadVdcLocation: builder.mutation({
      query: (id) => `static/public/nepal/district/${id}`,
    }),
    // loadPublicSchemeDetails: builder.mutation({
    //     query: (scheme_id) => `scheme/public/${scheme_id}`,
    // }),
    // placeOrderPublicScheme: builder.mutation({
    //     query: (body) => ({
    //         method: "POST",
    //         url: `order/public`,
    //         body,
    //     }),
    // }),
    // this is used in old flow not used
    // but since this is used in multiple codes it is not deleted.
    // loadPublicOfficeOptions: builder.query({
    //     query: (vdc_municipality_id) =>
    //         `office/public?page=1&size=0&find_vdc_municipality=${vdc_municipality_id}&find_type=RETAILER`,
    // }),
    // load public offices according to user location
    loadPublicOfficeList: builder.mutation({
      query: (vdc_municipality_id) =>
        `office/public?page=1&size=0&find_vdc_municipality=${vdc_municipality_id}&find_type=RETAILER&sort=name:asc`,
    }),

    loadBankList: builder.query({
      query: () => `setting/key/Data/Public/Bank`,
    }),
    // load district;
    // loadAvailableDistrictForUser: builder.query({
    //     query: () => `static/public/nepal/district`,
    // }),
    // load vdc;
    // loadAvailableVDCForUser: builder.mutation({
    //     query: (district_id) => `static/public/nepal/district/${district_id}`,
    // }),

    orderMultiBuy: builder.mutation({
      query: (body) => ({
        url: `order/public`,
        method: "POST",
        body,
      }),
    }),

    sendOtp: builder.mutation({
      query: (body) => ({
        url: `order/public/user`,
        method: "POST",
        body,
      }),
    }),
    verifyOtp: builder.mutation({
      query: (body) => ({
        url: `order/public/user/verify`,
        method: "POST",
        body,
      }),
    }),
    uploadPaymentVerification: builder.mutation({
      query: (formData) => ({
        url: `order/public/upload`,
        method: "POST",
        body: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    }),
    submitPayment: builder.mutation({
      query: (body) => ({
        url: `order/public/submit`,
        method: "POST",
        body,
      }),
    }),
    registerHandraiser: builder.mutation({
      query: (body) => ({
        url: `handraiser/public`,
        method: "POST",
        body,
      }),
    }),
    verifyHandraiserCode: builder.mutation({
      query: (body) => ({
        url: `handraiser/verify-code`,
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: true,
});

export const {
  useLoadSliderSectionQuery,
  useLoadProductsAvailableSchemePublicQuery,
  useLoadStateLocationQuery,
  useLoadDistrictLocationMutation,
  useLoadVdcLocationMutation,
  useLoadAllOfficeByTypeQuery,
  useOrderMultiBuyMutation,
  useSendOtpMutation,
  useVerifyOtpMutation,
  useUploadPaymentVerificationMutation,
  useLoadBankListQuery,
  useSubmitPaymentMutation,
  useRegisterHandraiserMutation,
  useVerifyHandraiserCodeMutation,
  // useLoadPublicSchemeDetailsMutation,
  // usePlaceOrderPublicSchemeMutation,
  // useLoadPublicOfficeOptionsQuery,
  // useLoadPublicOfficeListMutation,
  // useLoadAvailableDistrictForUserQuery,
  // useLoadAvailableVDCForUserMutation,
} = consumerPurchaseManageApiSlice;
